import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Snackbar from "../../../snackbar";
import { textFieldStyles } from "./styles";
import Dialog from "../../../dialog";
import { _parsePhoneNumber } from "../../../../partials/validateNumber";
import CountryCode from "../../../countryCode";
import ModulePackage from "../../../modulePackage";
// Component
import AddOwnerModal from "./editOwnerModal";
import InputFormat from "../../../../partials/inputForm";
import LabelForm from "../../../../partials/labelForm";

// Style
class EditService extends React.Component {
  state = {
    disabled: 0,
    service: {},
    ownerData: {},
    mobile: "",
    countryCode: this.props.defaultCountryCode || "+84",
  };

  componentDidMount() {
    this.setState({ service: this.props.service });
    this.getInfoOwnerSpa(this.props.service);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.service.no !== nextProps.service.no) {
      this.setState({ service: nextProps.service });
      this.getInfoOwnerSpa(nextProps.service);
    }
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      this.setState({ countryCode: nextProps.defaultCountryCode });
    }
  }
  getInfoOwnerSpa = async (service) => {
    if (service.userCode) {
      let check = await this.props.getInfoOwnerSpa({
        userCode: service.userCode,
      });
      if (check.code === 1) this.setState({ ownerData: check.data });
    }
  };
  addOwner = () => {
    let { mobile, countryCode, service } = this.state;
    if (_parsePhoneNumber(countryCode, mobile).isValid) {
      this.props.handleAddOwner({
        countryCode: countryCode,
        mobile: mobile,
        serviceCode: service.no,
      });
    } else this.mSnackbar.handleClick("Mobile is not valid", "warning");
  };
  openDialog = () => {
    this.mDialogRemoveOwner.handleDialogOpen();
  };
  removeOwner = () => {
    this.mDialogRemoveOwner.handleDialogClose();
    this.props.handleRemoveOwner({ serviceCode: this.state.service.no });
  };
  handleChangeActive = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let service = this.state.service;
    let { t } = this.props;
    service[name] = e.target.checked ? 1 : 0;
    let check = await this.props.serviceDispatch.activeServiceForAdmin({
      serviceCode: service.no,
      isActive: service[name],
    });
    if (check.code === 1) {
      this.setState({ service });
      if (service[name])
        this.props.handleChangeActive(
          t("service_admin_listservice_editservice_status_changed_to_active")
        );
      else
        this.props.handleChangeActive(
          t("service_admin_listservice_editservice_status_changed_to_inactive")
        );
    } else {
      this.props.handleChangeActive(check.message);
    }
  };
  handleChange = (name, value) => {
    let state = this.state;
    state[name] = value;
    this.setState(state);
  };

  render() {
    const { classes, t } = this.props;
    let { service, ownerData } = this.state;
    if (Object.keys(this.state.service).length > 0) {
      return (
        <form className={classes.container} noValidate autoComplete="off">
          <Dialog
            onRef={(dialog) => (this.mDialog = dialog)}
            disagree={t("service_ownerspa_servicedetail_cancel")}
            agree={t("service_ownerspa_servicedetail_update")}
            title={t("service_ownerspa_servicedetail_update")}
            content={t(
              "service_ownerspa_servicedetail_do_you_want_to_update_them"
            )}
            action={this.handleSubmit}
          />
          <Dialog
            onRef={(dialog) => (this.mDialogRemoveOwner = dialog)}
            disagree={t("service_ownerspa_servicedetail_cancel")}
            agree={t("service_admin_listservice_editservice_remove_owner_spa")}
            title={t("notice")}
            content={t(
              "service_admin_listservice_editservice_remove_owner_information"
            )}
            action={this.removeOwner}
          />
          <ModulePackage onRef={(id) => (this.ModulePackage = id)} />
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <LabelForm
                label={t("service_admin_listservice_editservice_active_status")}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className="submitActive">
                <FormControlLabel
                  control={
                    <Switch
                      classes={{
                        switchBase: classes.iOSSwitchBase,
                        bar: classes.iOSBar,
                        icon: classes.iOSIcon,
                        iconChecked: classes.iOSIconChecked,
                        checked: classes.iOSChecked,
                      }}
                      disableRipple
                      checked={this.state.service.isActive === 1 ? true : false}
                      onChange={this.handleChangeActive}
                      name="isActive"
                    />
                  }
                  label={
                    <label className={classes.label}>
                      {t("service_admin_createservice_information_active")}
                    </label>
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <LabelForm
                label={t(
                  "service_admin_listservice_editservice_owner_infomation"
                )}
              />
            </Grid>
            {this.state.service.userCode && (
              // Address */}
              <Grid item xs={4} sm={4}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("service_admin_listservice_editservice_address")}
                  name="address"
                  margin="none"
                  value={this.state.ownerData.address}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              // First name  */}
              <Grid item xs={2} sm={2}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("profile_first_name")}
                  name="address"
                  margin="none"
                  value={this.state.ownerData.firstName || ""}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              // Last name   */}
              <Grid item xs={2} sm={2}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("profile_last_name")}
                  name="address"
                  margin="none"
                  value={this.state.ownerData.lastName || ""}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              // Mobile */}
              <Grid item xs={4} sm={4}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("servicebranch_mobile")}
                  margin="none"
                  value={
                    _parsePhoneNumber(
                      this.state.ownerData.countryCode,
                      this.state.ownerData.username
                    ).format_internal || ""
                  }
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              // Email */}
              <Grid item xs={4} sm={4}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("Email")}
                  name="address"
                  margin="none"
                  value={this.state.ownerData.email || ""}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              // dob */}
              <Grid item xs={4} sm={4}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("profile_dob")}
                  name="dob"
                  margin="none"
                  value={
                    this.state.ownerData.dob
                      ? moment(this.state.ownerData.dob, "YYYY-MM-DD").format(
                          "DD-MM-YYYY"
                        )
                      : ""
                  }
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {this.state.service.userCode && (
              <Grid item xs={4} sm={4}>
                <InputFormat
                  disabled
                  disable="true"
                  id="multiline-flexible"
                  label={t("service_admin_owner_code")}
                  name="address"
                  margin="none"
                  value={this.state.service.userCode || ""}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            {!this.state.service.userCode && (
              <Grid item xs={12} sm={2} className={classes.boxCountryCode}>
                <CountryCode
                  code={this.state.countryCode}
                  handleCountryCode={this.handleChange}
                  margin="normal"
                />
              </Grid>
            )}
            {!this.state.service.userCode && (
              <Grid item xs={12} sm={10}>
                <InputFormat
                  required
                  id="multiline-flexible"
                  label={t("servicebranch_mobile")}
                  name="mobile"
                  margin="normal"
                  value={this.state.mobile || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.name, e.target.value)
                  }
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12}>
              <div className={classes.containerButton}>
                {ownerData && ownerData.userCode ? (
                  <Link
                    to={{
                      pathname: `/service-admin/module`,
                      search: `?serviceCode=${this.state.service.no}`,
                      state: {
                        adminService: this.state.service,
                      },
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      component="span"
                      className={classes.buttonModule}
                    >
                      {t("service_admin_listservice_editservice_permisstion")}
                    </Button>
                  </Link>
                ) : (
                  <Button
                    disabled={true}
                    color="primary"
                    variant="contained"
                    component="span"
                    className={classes.buttonModule}
                  >
                    {t("service_admin_listservice_editservice_permisstion")}
                  </Button>
                )}
                {ownerData && ownerData.userCode ? (
                  <Link
                    to={{
                      pathname: `/service-admin/owner`,
                      search: `?serviceCode=${this.state.service.no}`,
                      // state: {
                      //   adminService: this.state.service,
                      // }
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      component="span"
                      className={classes.buttonModule}
                    >
                      {t(
                        "service_admin_listservice_editservice_service_account"
                      )}
                    </Button>
                  </Link>
                ) : (
                  <Button
                    disabled={true}
                    color="primary"
                    variant="contained"
                    component="span"
                    className={classes.buttonModule}
                  >
                    {t("service_admin_listservice_editservice_service_account")}
                  </Button>
                )}
                {this.state.service.userCode ? (
                  <Button
                    onClick={this.openDialog}
                    color="primary"
                    variant="contained"
                    component="span"
                    className={classes.button}
                  >
                    {t(
                      "service_admin_listservice_editservice_remove_owner_spa"
                    )}
                  </Button>
                ) : (
                  <Button
                    onClick={this.addOwner}
                    color="primary"
                    variant="contained"
                    component="span"
                    className={classes.button}
                  >
                    {t("service_admin_listservice_editservice_add_owner_spa")}
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </form>
      );
    } else {
      return <div></div>;
    }
  }
}

EditService.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  serviceDispatch: dispatch.service,
  getInfoOwnerSpa: dispatch.user.getInfoOwnerSpa,
  userDispatch: dispatch.user,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(textFieldStyles)(EditService)));
